module.exports = __webpack_public_path__ + "static/media/02_twitter_image.045f18fe.jpg";